import { Component, enableProdMode } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { NotificationWrapperComponent } from './components/notification-wrapper/notification-wrapper.component';
import { LoginToWavesComponent } from './components/login-to-waves/login-to-waves.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    NgOptimizedImage,
    RouterOutlet,
    NotificationWrapperComponent,
    LoginToWavesComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor() {
    enableProdMode();
  }

  title = 'pluto';
}
